import { Provider } from "react-redux";
import BooksContainer from "./components/BooksContainer";
import Navbar from "./components/Navbar";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <Navbar />
      <BooksContainer />
    </Provider>
  );
}

export default App;
